var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSubpasta01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1564",
    d: "M30,20h-7.7c-0.6,0-1.1-0.3-1.4-0.8l-1.1-2.1c-0.4-0.9-1.3-1.4-2.3-1.4h-4.8c-1.4,0-2.6,1.2-2.6,2.6v14.7 c0,1.4,1.2,2.6,2.6,2.6H30c1.4,0,2.6-1.2,2.6-2.6V22.6C32.6,21.2,31.4,20,30,20z M12.7,16.7h4.8c0.6,0,1.1,0.3,1.4,0.8l1.1,2.1 c0.1,0.1,0.1,0.2,0.2,0.4h-9.1v-1.7C11.1,17.4,11.8,16.7,12.7,16.7L12.7,16.7z M31.5,32.9c0,0.9-0.7,1.6-1.6,1.6H12.7 c-0.9,0-1.6-0.7-1.6-1.6V21h10.7c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.4,0H30c0.9,0,1.6,0.7,1.6,1.6V32.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1565",
    d: "M3.4,0.5V27c0,1.4,1.2,2.6,2.6,2.6h4v-0.8H7.2c-0.8,0.1-1.5,0-2.2-0.4c-0.5-0.4-0.8-1-0.8-1.6V0.5 L3.4,0.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSubpasta01);
export default __webpack_public_path__ + "static/media/ico-subpasta-01.add877abf719fc68111d61720d604bde.svg";
export { ForwardRef as ReactComponent };